import { Button } from 'react-bootstrap';
import styles from './ExploreButton.module.scss';
import { showRightArrowIcon } from '../../core/core';

const ExploreButton = ({ small, disabled, ...otherProps }) => (
  <div className={styles.exploreButton}>
    <Button {...otherProps}>Explore &nbsp;{showRightArrowIcon()}</Button>
  </div>
);

export default ExploreButton;
